import React from 'react';
import { GatsbyImage, IGatsbyImageData } from 'gatsby-plugin-image';
import { processLink } from '../../../shared/processLink';
import { ReachButton } from '../../ReachButton/ReachButton';
import './AwardCard.scss';

export interface AwardCardProps {
    isDarkMode: boolean;
    awardCard: IAwardCardProp[];
}

interface IAwardCardProp {
    heading?: string;
    subtitle?: string;
    link?: IAwardCardLink;
    image?: IGatsbyImageData;
}

interface IAwardCardLink {
    title: string;
    uri: string;
}

export const AwardCard = (props: AwardCardProps) => {
    if (!props) return;

    const { isDarkMode, awardCard } = props;

    return (
        <section className={`award-cards ${isDarkMode ? `dark` : `light`}`}>
            <ul className="award-cards-wrapper">
                {awardCard?.map((card, idx) => (
                    <li key={idx} className="award-card">
                        {card.image && (
                            <div className="img" data-testid={`award-image`}>
                                <GatsbyImage image={card.image} alt="" />
                            </div>
                        )}
                        <div className="award-card-content">
                            {card.heading && (
                                <h2 className="typestack-title-5">
                                    {card.heading}
                                </h2>
                            )}
                            {card.subtitle && (
                                <h3 className="typestack-title-6">
                                    {card.subtitle}
                                </h3>
                            )}
                            {card.link.uri && (
                                <div className="buttons">
                                    <ReachButton
                                        href={processLink(card.link.uri)}
                                        buttonStyle="borderless"
                                        buttonIcon={{
                                            icon: `ki-arrow-right`,
                                            position: `right`,
                                            iconSize: `1rem`,
                                        }}
                                    >
                                        <span data-testid={`award-card-button`}>
                                            {card.link.title}
                                        </span>
                                    </ReachButton>
                                </div>
                            )}
                        </div>
                    </li>
                ))}
            </ul>
        </section>
    );
};
